<fx-header (drawerClick)="onDrawerClick($event)"></fx-header>
<div class="body bg-dark" (click)="onDrawerClick('body')">
  <div class="sidenav ">
    <fx-aside (navClick)="onNavClick($event)" (drawerClick)="onDrawerClick($event)"></fx-aside>
  </div>
  <div class="page-content">
    <router-outlet></router-outlet>
  </div>
</div>
<!-- <fx-footer></fx-footer> -->
